import React from 'react';
import c from '../w.js';

const IconTimelineIndicator = React.memo(
  c(
    /* @__PURE__ */ React.createElement("path", { d: "M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12Z" })
  )
);

export { IconTimelineIndicator };
